<!-- ./Contact Us -->
<section class="section mt-7n">
  <div class="container bring-to-front pt-0">
    <div class="row align-items-center gap-y">
      <div class="col-md-6">
        <div class="shadow bg-form p-4 rounded">
          <dc-form-contact></dc-form-contact>
        </div>
      </div>

      <div class="col-md-5 ml-md-auto">
        <div class="section-heading" style="padding-top: 60px;">
          <!-- <dc-badge [bg]="'primary'" [text]="'contrast'" [small]
            >Siempre disponibles</dc-badge
          > -->
          <h2 style="font-size: 2.4rem !important;">Contacte con nosotros</h2>
        </div>

        <div class="media">
          <fa-icon
            [icon]="fa.mapMarker"
            [class]="'font-l text-primary mr-3'"
          ></fa-icon>
          <div class="media-body">
            C/ Jaume Balmes, 26 Bajos A<span class="d-block"
              >07005, Palma (Illes Balears)</span
            >
          </div>
        </div>

        <div class="media my-4">
          <fa-icon
            [icon]="fa.phone"
            [class]="'font-l text-primary mr-3'"
          ></fa-icon>
          <div class="media-body">
            <span class="d-block"
              ><a href="tel:+34971436950" style="color: #00365F;"
                >971 43 69 50</a
              ></span
            >
            <!-- <span class="d-block"
              ><a href="tel:+34868680989" style="color: #00365F;"
                >868 68 09 89</a
              ></span
            > -->
          </div>
        </div>

        <div class="media">
          <fa-icon
            [icon]="fa.envelope"
            [class]="'font-l text-primary mr-3'"
          ></fa-icon>
          <div class="media-body">
            <a href="mailto:info@grupox3.es" style="color: #00365F;"
              >info@grupox3.es</a
            >
          </div>
        </div>

        <hr class="my-4" />

        <!-- <nav class="nav justify-content-center justify-content-md-start">
          <a href="#" class="btn btn-circle btn-sm brand-facebook mr-3">
            <fa-icon [icon]="fa.facebook"></fa-icon>
          </a>
          <a href="#" class="btn btn-circle btn-sm brand-twitter mr-3">
            <fa-icon [icon]="fa.twitter"></fa-icon>
          </a>
          <a href="#" class="btn btn-circle btn-sm brand-instagram">
            <fa-icon [icon]="fa.instagram"></fa-icon>
          </a>
        </nav> -->
      </div>
    </div>
  </div>
</section>
